import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import ServiceAreasSection from '../components/ServiceAreasSection';
import AboutSection from '../components/AboutSection';
import Footer from '../components/Footer';
import StickyCallButton from '../components/StickyCallButton';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const HomePage = () => {
  useEffect(() => {
    // Track visitor when page loads
    const trackVisit = async () => {
      try {
        await axios.post(`${API}/track-visit`);
      } catch (error) {
        console.error('Error tracking visit:', error);
      }
    };
    
    trackVisit();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ServicesSection />
      <ServiceAreasSection />
      <AboutSection />
      <Footer />
      <StickyCallButton />
    </div>
  );
};

export default HomePage;
